import Sticky from "react-sticky-el"

import StickyNavHeader from "@/components/ProductDetail/v3/StickyHeader"
import { getPresetThumbnailUrl } from "@/utils/index"
import { useEffect, useState } from "react"
import useWindowResize from "@/hooks/useWindowResize"

const StickyHead = props => {
  const {
    setSticky,
    sticky = false,
    isDiscontinued = "",
    stickyHeaderProps = {},
    discountedPrice = 0,
    warehouses = [],
    price = 0,
    staticTexts = {},
    onAddToCart,
    isColorDiscontinued = "",
    addToCartProps = {},
    productOnStock = "",
    sku = "",
    customerFacingSKU = "",
    isComboSku = "",
    handleScroll,
    onAvailableColor = "",
    isRegionSoldOnline = "",
    productAnalyticsData = {},
    customerBrandName = "",
    replaceAddToCart = "",
    disableRatings = "",
    replaceAddToCartCtaLink = "",
    replaceAddToCartCtaLabel = "",
    linkNewTab = "",
    disableEcommerce = "",
    currencySign = "",
    swatchUrl = "",
    imagesData = {},
    presetConfigObject = {},
    assetAccountName = "",
    productPriceSpiderIncluded = "",
    productInfo = {},
    installError,
    setPinCodeError,
    isBundle = false,
    isOutOfStock = "",
    installServiceData,
    setInstallServiceData,
    isChecked,
    bundleItems = { bundleItems },
    pinCodeError,
    isEtaLoading=false,
    isPdpPropsLoaded
  } = props
  const [width] = useWindowResize()
  const [isMobile, setIsMobile] = useState(width <= 991)
  useEffect(() => {
    setIsMobile(width <= 991)
  }, [width])
  return (
    <Sticky
      onFixedToggle={() => setSticky(!sticky)}
      className="product-detail-page__sticky-wrapper"
      stickyClassName={"sticky sticky-pdp-page"}
    >
      {!isDiscontinued && sticky && isMobile && (
        <StickyNavHeader
          {...stickyHeaderProps}
          currencySign={currencySign}
          price={discountedPrice > 0 ? discountedPrice : price}
          staticTexts={staticTexts}
          warehouses={warehouses}
          imgUrl={getPresetThumbnailUrl(
            swatchUrl,
            imagesData[0]?.assetId,
            presetConfigObject,
            assetAccountName,
            imagesData[0]?.url
          )}
          onAddToCart={(cartItemProduct, cb) =>
            onAddToCart(cartItemProduct, cb)
          }
          isDiscontinued={isDiscontinued}
          isColorDiscontinued={isColorDiscontinued}
          specialOrder={addToCartProps.specialOrder}
          backOrder={addToCartProps.backOrder}
          productStock={productOnStock}
          sku={sku}
          customerFacingSKU={customerFacingSKU}
          isComboSku={isComboSku}
          handleScroll={handleScroll}
          onAvailableColor={() => onAvailableColor()}
          productPriceSpiderIncluded={productPriceSpiderIncluded}
          isRegionSoldOnline={isRegionSoldOnline}
          analyticData={productAnalyticsData.stringProductInfo}
          customerBrandName={customerBrandName}
          replaceAddToCart={replaceAddToCart}
          disableRatings={disableRatings}
          replaceAddToCartCtaLink={replaceAddToCartCtaLink}
          replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
          linkNewTab={linkNewTab}
          disableEcommerce={disableEcommerce}
          productInfo={productInfo}
          installError={installError}
          setPinCodeError={setPinCodeError}
          isOutOfStock={isOutOfStock}
          installServiceData={installServiceData}
          setInstallServiceData={setInstallServiceData}
          isInstallationAdded={isChecked}
          isBundle={Boolean(bundleItems.length)}
          pinCodeError={pinCodeError}
          isEtaLoading={isEtaLoading}
          isPdpPropsLoaded={isPdpPropsLoaded}
        />
      )}
    </Sticky>
  )
}

export default StickyHead
